<template>
  <div
    class="bg-white border border-charcoal-100 rounded-xl relative p-2 space-x-1"
    @contextmenu.prevent.stop="() => showContextMenu({ user, event, group }, context)"
  >
    <div class="flex items-center grow space-x-2">
      <UserPicture :user="user" class="shrink-0" size="md" is-tooltip />

      <div class="grow leading-tight shrink-0">
        <div class="flex items-center space-x-1">
          <p class="line-clamp-1 font-bold text-base break-all">{{ user.name }}</p>

          <div><span class="font-medium text-2xs text-charcoal-500" v-if="user.pronouns && user.pronouns.length > 0">{{ user.pronouns.join(' / ') }}</span></div>
        </div>

        <div class="text-xs text-charcoal-500 font-medium line-clamp-1 break-all">
          <div v-if="event">
            <span class="text-royal-600" v-if="event.isOrganizing(user._id)">
              {{ $t('components.Event.attendeeState.organizer') }}
            </span>
            <span v-else-if="event.getAttendance(user._id)?.type === 'checked-in'">
              {{ $t('components.Event.attendeeState.checkedIn') }}
            </span>
            <span v-else-if="event.getAttendance(user._id)?.type === 'waiting'">
              {{ $t('components.Event.attendeeState.waiting') }}
            </span>
            <span class="text-emerald-400" v-else-if="event.getAttendance(user._id)?.type === 'attending' && user.attendedCount <= 0">
              <IconBase name="cute/sparkles-fill" :width="12" class="-mt-0.5" /> {{ $t('components.Event.attendeeState.first') }}
            </span>
            <span class="text-ruby-500" v-else-if="event.getAttendance(user._id)?.type === 'attending' && user.attendanceGrade === 'bad' && event.isOrganizing(currentUser?._id)">
              {{ $t('components.Event.attendeeState.fiabilityBad') }}
            </span>
            <span class="text-tiger-400" v-else-if="event.getAttendance(user._id)?.type === 'attending' && user.attendanceGrade === 'mid' && event.isOrganizing(currentUser?._id)">
              {{ $t('components.Event.attendeeState.fiabilityMediocre') }}
            </span>
            <span v-else-if="event.getAttendance(user._id)?.type === 'attending'">
              {{ $t('components.Event.attendeeState.attending') }}
            </span>

          </div>
          <template v-else-if="groupRole">
            <span :class=" [ groupRole === 'admin' ? 'text-urchin-500' : (groupRole === 'organizer' ? 'text-tiger-500' : '') ]">
              {{ $t('components.Group.roles.' + groupRole) }}
            </span>
          </template>
        </div>
      </div>

      <slot />
    </div>

    <slot name="after" />

    <ChipRound size="xs" class="shrink-0" color="charcoal" v-if="event && (event.getAttendance(user._id)?.guests ?? 0) > 0">
      +{{ event.getAttendance(user._id)?.guests }}
    </ChipRound>

    <ButtonBase style-type="round" color="white" :size="size === 'md' ? 'xs' : '2xs'" @click="() => showContextMenu({ user, event, group }, context)" v-if="!isHideContext">
      <IconBase name="cute/dots-h" :width="14" />
    </ButtonBase>
  </div>
</template>

<script lang="ts" setup>
import ContextStore from '@/store/context'
import { User, Event, Group } from '@/classes'
import { ContextActions } from '@/utils/useContext'
import UserStore from '@/store/user'

const props = withDefaults(defineProps<{
  user: User
  size?: 'base' | 'md'
  group?: Group
  event?: Event
  isHideContext?: boolean
  context?: (keyof typeof ContextActions)[]
}>(), {
  size: 'base',
  isHideContext: false,
  context: undefined
})

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const groupRole = computed(() => props.group?.getRole(props.user._id))

const { showContextMenu } = ContextStore()

</script>